import React from 'react';
import { X, Check } from 'lucide-react';
const comparisons = [{
  sin: '3-5 horas/semana planificando desde cero',
  con: '10 min/semana. El resto es estar en el agua'
}, {
  sin: 'Siempre las mismas series → los alumnos se aburren',
  con: '60+ clases distintas → siempre hay algo nuevo'
}, {
  sin: 'Alumnos que abandonan sin saber por qué',
  con: 'Sistema de progresión → retención visible'
}, {
  sin: 'Sin progresión clara de nivel a nivel',
  con: '6 tomos con progresión anual → mejoran y se quedan'
}, {
  sin: 'Alumno con dificultad técnica = pánico o improvisación',
  con: 'Protocolo técnico → actuás con confianza y criterio'
}, {
  sin: 'Niveles mezclados = caos de clase',
  con: 'Variaciones por nivel → todos mejoran juntos'
}, {
  sin: 'Sin sistema de seguimiento claro',
  con: 'Fichas y planillas listas para registrar con criterio'
}, {
  sin: 'Sin identidad profesional visible',
  con: 'Sistema que justifica cobrar lo que merecés'
}];
export function CostComparisonTable() {
  return <section className="bg-gray-50 py-8 sm:py-16 px-4 sm:px-6 lg:px-8" data-id="element-51">
      <div className="max-w-4xl mx-auto" data-id="element-52">
        <h2 className="text-3xl sm:text-4xl font-black text-deep mb-6 sm:mb-10 text-center" data-id="element-53">
          ¿Cuánto cuesta NO tenerlo?
        </h2>

        <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden" data-id="element-54">
          {/* Headers */}
          <div className="grid grid-cols-2" data-id="element-55">
            <div className="bg-red-50 p-3 sm:p-6 text-center border-b border-r border-gray-200" data-id="element-56">
              <h3 className="font-bold text-red-800 text-sm sm:text-base uppercase tracking-wider" data-id="element-57">
                SIN PROFE DE NATACIÓN RESUELTO
              </h3>
            </div>
            <div className="bg-green-50 p-3 sm:p-6 text-center border-b border-gray-200" data-id="element-58">
              <h3 className="font-bold text-green-800 text-sm sm:text-base uppercase tracking-wider" data-id="element-59">
                CON PROFE DE NATACIÓN RESUELTO
              </h3>
            </div>
          </div>

          {/* Rows */}
          <div className="divide-y divide-gray-100" data-id="element-60">
            {comparisons.map((row, idx) => <div key={idx} className={`grid grid-cols-2 ${idx % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'}`} data-id="element-61">
                <div className="p-3 sm:p-5 border-r border-gray-100 flex items-start gap-3" data-id="element-62">
                  <X className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-63" />
                  <span className="text-sm sm:text-base text-gray-700" data-id="element-64">
                    {row.sin}
                  </span>
                </div>
                <div className="p-3 sm:p-5 flex items-start gap-3" data-id="element-65">
                  <Check className="w-5 h-5 text-green-600 shrink-0 mt-0.5" data-id="element-66" />
                  <span className="text-sm sm:text-base font-medium text-gray-900" data-id="element-67">
                    {row.con}
                  </span>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}